import { render } from "./testPage.vue?vue&type=template&id=6f48195e&scoped=true"
import script from "./testPage.vue?vue&type=script&lang=js"
export * from "./testPage.vue?vue&type=script&lang=js"

import "./testPage.vue?vue&type=style&index=0&id=6f48195e&scoped=true&lang=scss"

import exportComponent from "/pxplus_redirect/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f48195e"]])

export default __exports__